<div
  #playerShellRef
  class="vimeo-video__player-shell"
  (mouseenter)="onVideoMouseEnter()"
  (mouseleave)="onVideoMouseLeave()"
  *ngIf="sources && sources.length > 0"
>
  <video
    #vimeoVideoRef
    class="vimeo-video__video video-js"
    [poster]="poster"
    [preload]="preloadModeSig()"
    [attr.autoplay]="autoplaySig() ? '' : null"
    [attr.muted]="mutedSig() ? '' : null"
    playsinline
  >
    <source
      *ngFor="let source of sources"
      [attr.src]="source.link"
      [attr.type]="source.type"
      [attr.label]="source.public_name"
      [attr.selected]="source.quality === 'hd' ? true : null"
    />

    <ng-content class="vjs-no-js" select="[not-supported-source]"></ng-content>
  </video>

  <button
    #overlayButtonRef
    type="button"
    class="vimeo-video__overlay-button"
    [class.vimeo-video__overlay-button--hidden]="!shouldShowOverlayButton"
    [class.vimeo-video__overlay-button--center]="shouldCenterOverlayButton"
    [class.vimeo-video__overlay-button--vertical-default]="
      !shouldCenterOverlayButton && isVerticalLayout && !isFullscreen
    "
    [class.vimeo-video__overlay-button--horizontal-default]="
      !shouldCenterOverlayButton && (!isVerticalLayout || isFullscreen)
    "
    [attr.aria-label]="isPlaying ? 'Pause video' : 'Play video'"
    (click)="handleOverlayButtonClick()"
  >
    <span
      class="vimeo-video__overlay-icon"
      [class.vimeo-video__overlay-icon--pause]="overlayButtonIcon === 'pause'"
      aria-hidden="true"
    ></span>
  </button>

  <button
    #controlsToggleRef
    *ngIf="shouldShowControlsToggle"
    type="button"
    class="vimeo-video__controls-toggle"
    [attr.aria-label]="areControlsExpanded ? 'Hide controls' : 'Show controls'"
    [class.vimeo-video__controls-toggle--hover-visible]="hasStartedPlayback"
    (click)="toggleControlsVisibility()"
  >
    <span
      class="dx-icon"
      [class.dx-icon-chevronleft]="!areControlsExpanded"
      [class.dx-icon-chevronright]="areControlsExpanded"
      aria-hidden="true"
    ></span>
  </button>

  <ag-shr-vimeo-video-share-popup
    [visible]="isSharePanelVisible"
    [container]="popupContainerElement || playerShellRef"
    [isPrivateVideo]="isPrivateVideo"
    [privateVideoMessage]="privateVideoMessage"
    [shareLink]="shareLink"
    [copyButtonText]="copyButtonText"
    (closeRequested)="closeSharePanel()"
    (copyRequested)="handleCopyButtonClick()"
    (shareRequested)="shareTo($event)"
  ></ag-shr-vimeo-video-share-popup>
</div>
